/* c8 ignore start */
import { SAT_SERVICE } from "@/utils/services";

const satPages = [
  {
    path: "overview",
    name: "customer-security_awareness_training-overview",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/overview/overview.index.vue"
      ),
  },
  {
    path: "overview/schedule_sat",
    name: "customer-security_awareness_training-overview-schedule_sat",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/schedule-sat/schedule-sat.index.vue"
      ),
  },
  {
    path: "sat_campaigns",
    name: "customer-security_awareness_training-sat_campaigns",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/sat-campaigns/campaigns.index.vue"
      ),
  },
  {
    path: "sat_campaigns/details",
    name: "customer-security_awareness_training-sat_campaigns-details",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/campaign-details/campaign-details.index.vue"
      ),
  },
  {
    path: "sat_campaigns/schedule_sat",
    name: "customer-security_awareness_training-sat_campaigns-schedule_sat",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/schedule-sat/schedule-sat.index.vue"
      ),
  },
  {
    path: "content_manager",
    name: "customer-security_awareness_training-content_manager",
    component: () =>
      import(
        "@/modules/SecurityAwarnessTraining/views/Customer/content-manager/content-manager.index.vue"
      ),
  },
];

const customerRoutes = {
  path: "/customer",
  component: () => import("@/layouts/Customer/CustomerLayout.vue"),
  children: [
    {
      path: "security_awareness_training",
      name: "customer-security_awareness_training",
      component: () =>
        import(
          "@/modules/SecurityAwarnessTraining/views/Customer/customer.index.vue"
        ),
      redirect: {
        name: "customer-security_awareness_training-overview",
      },
      meta: {
        solutionId: SAT_SERVICE,
      },
      children: satPages,
    },
  ],
};

export { customerRoutes };

export default {};
/* c8 ignore end */
